import { useState } from "react";
import { api, ApiError } from "../lib/api.js";
import { useRouter } from "../lib/router.js";
import { useSession, type SessionUser } from "../lib/session.js";
import { Logo } from "../components/ui.js";

export function LoginPage() {
  const { setUser } = useSession();
  const { navigate } = useRouter();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const result = await api.post<{ user: SessionUser }>("/api/auth/login", {
        username,
        password
      });
      setUser(result.user);
      navigate("/today", { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Something went wrong.");
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-layout">
      <div className="auth-card">
        <div className="auth-brand">
          <Logo size={88} />
          <span className="auth-tagline">Build the body. Build the system.</span>
        </div>
        <h1 className="auth-title">Welcome back</h1>
        <p className="auth-sub">Sign in to your ClovaForm account.</p>

        {error && <div className="alert alert-danger">{error}</div>}

        <form onSubmit={onSubmit} noValidate>
          <div className="field">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              className="input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              required
            />
          </div>
          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              className="input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          <button className="btn btn-primary btn-block" type="submit" disabled={submitting}>
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="auth-sub mt-6" style={{ marginBottom: 0 }}>
          ClovaForm is invite-only. Ask an administrator for an invitation if you
          don't have an account.
        </p>
      </div>
    </div>
  );
}
